import { MajorExplorerCapabilityConfiguration } from '../../configuration';

export class SurveyInterestModalController {
  constructor(
    private myIntakeHistoryModel: any,
    private ngMajorExplorerCapabilityConfiguration: MajorExplorerCapabilityConfiguration
  ) {}
}

export class SurveyInterestModalComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-major-explorer/src/modals/view_interests_modal/survey_view_your_interests_modal.html';
  public controller: any = SurveyInterestModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/modals/view_interests_modal/survey_view_your_interests_modal.ts